export const DataTestId = {
    CaretDownIcon: 'caret-down-icon',
    CloseIcon: 'close-icon',
    ExpertsProfileModal: 'experts-profile-modal-wrapper',
    ExpertsTable: 'experts-table-wrapper',
    FilterSection: 'filter-section-wrapper',
    Header: 'header-wrapper',
    InputBox: 'input-box-wrapper',
    LayoutContent: 'content-wrapper',
    Loader: 'loader-wrapper',
    Popover: 'popover-wrapper',
    SearchBox: 'search-box-wrapper',
    Select: 'select-wrapper',
    SelectMultipleCheckbox: 'select-multiple-checkbox-wrapper',
    SelectRangeInputMin: 'select-range-input-min-wrapper',
    SelectRangeInputMax: 'select-range-input-max-wrapper',
    SelectRangeDropdown: 'select-range-dropdown-wrapper',
    SelectTestDropdown: 'select-test-dropdown-wrapper',
    SelectTestOption: 'select-test-option-wrapper',
    SidebarFilter: 'sidebar-filter-wrapper',
    SidebarFilterCheckbox: 'sidebar-filter-checkbox-wrapper',
    SidebarPanel: 'sidebar-panel-wrapper',
    SkillsPopover: 'skills-popover-wrapper',
    SkillsTable: 'skills-table-wrapper',
    SkillTimeline: 'skill-timeline-wrapper',
    Table: 'table-wrapper',
    Tag: 'tag-wrapper',
    TagSection: 'tag-section-wrapper',
    TelusLogo: 'telus-logo',
    UIButton: 'ui-button-wrapper',
    UserProfile: 'user-profile-wrapper',
}

export const TextConstants = {
    UserProfile: {
        PrivacyPolicy: 'Privacy Policy',
        Logout: 'Logout',
    },
    SkillTimeline: {
        SkillValidationLog: 'Skill validation log',
    },
    SkillsPopover: {
        Skills: 'skills',
    },
    SidebarFilter: {
        SelectLevel: 'Select level',
        SelectValidationSource: 'Select validation source',
        SelectScore: 'Select score',
        ApplyFilters: 'Apply filters',
    },
    SidebarPanel: {
        SearchSkill: 'Search skill',
        FilterBySkill: 'Filter by skill',
    },
    FilterSection: {
        SearchByNameEmail: 'Search by name/email ID',
        SearchByExpertiseArea: 'Search by expertise area',
        ByLocation: 'By location',
        ByOccupation: 'By occupation',
        ByEducationDegree: 'By education degree',
        ByEducationMajor: 'By education major',
        ByYearsOfExperience: 'By years of experience',
        ByLanguages: 'By languages',
        ByLifeCycleStage: 'By lifecycle stage',
        ApplyFilters: 'Apply filters',
    },
    Header: {
        ExpertsEngine: 'Experts Engine',
    },
    ExpertsProfileModal: {
        Close: 'Close',
        ExpertsProfile: "Expert's profile",
        FetchingData: 'Fetching data',
        Qualified: 'Qualified',
        TalentStudioProfile: 'Talent Studio profile',
        PersonalInformation: 'Personal information',
        Skills: 'Skills',
    },
    ExpertsPage: {
        SearchForExperts: 'Search for experts',
        ExportAllToCSV: 'Export all to CSV',
        ExportSelectedToCSV: 'Export selected to CSV',
        ExpertsSelected: 'Experts selected',
        FetchingData: 'Fetching data',
        ExportSuccessful: 'Export successful',
    },
    SelectRange: {
        EnterARange: 'Enter a range',
        Description: "Press 'Enter' to apply range",
    },
    TagSection: {
        FilterBySkill: 'Filter by skill',
        HideFilters: 'Hide filters',
        MoreFilters: 'More filters',
        ClearFilters: 'Clear filters',
    },
}
